"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var ItemTransactionDetailResponse;
(function (ItemTransactionDetailResponse) {
    var ItemTransactionDetail = (function (_super) {
        __extends(ItemTransactionDetail, _super);
        function ItemTransactionDetail() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.bookId = undefined;
            _this.isbn = undefined;
            _this.title = undefined;
            _this.author = undefined;
            _this.description = undefined;
            _this.unitPrice = undefined;
            _this.finalPrice = undefined;
            _this.quantity = undefined;
            return _this;
        }
        return ItemTransactionDetail;
    }(BaseModel_1["default"]));
    ItemTransactionDetailResponse.ItemTransactionDetail = ItemTransactionDetail;
})(ItemTransactionDetailResponse = exports.ItemTransactionDetailResponse || (exports.ItemTransactionDetailResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/itemTransactionDetail.js
// module id = ../model/dist/models/itemTransactionDetail.js
// module chunks = main